import createReducer from 'shared/utils/createReducer';
import { LOGOUT } from 'modules/auth/actions/logout';

import requestsStatuses from 'modules/common/constants/requestsStatuses';
import { HIDE_APPOINTMENT_INFO } from 'modules/queues/common/actions/appointmentInfo';
import { FETCH_CASE_DATA_FORM } from '../actions/fetchCaseDataForm';
import { CLEAR_CASE_DATA_FORM, UPDATE_CASE_DATA_FORM } from '../actions/updateCaseDataForm';

const defaultState = {
  caseDataFormRequestStatus: requestsStatuses.default,
  caseDataFormUpdateStatus: requestsStatuses.default,
  caseDataForm: undefined,
};

export default createReducer(defaultState, {
  [FETCH_CASE_DATA_FORM.pending]: state => ({
    ...state,
    caseDataFormRequestStatus: requestsStatuses.pending,
  }),
  [FETCH_CASE_DATA_FORM.success]: (state, { payload }) => ({
    ...state,
    caseDataForm: payload,
    caseDataFormRequestStatus: requestsStatuses.success,
  }),
  [FETCH_CASE_DATA_FORM.failure]: state => ({
    ...state,
    caseDataFormRequestStatus: requestsStatuses.failure,
  }),

  [UPDATE_CASE_DATA_FORM.pending]: state => ({
    ...state,
    caseDataFormUpdateStatus: requestsStatuses.pending,
  }),
  [UPDATE_CASE_DATA_FORM.success]: (state, { payload }) => ({
    ...state,
    caseDataForm: payload,
    caseDataFormUpdateStatus: requestsStatuses.success,
  }),
  [UPDATE_CASE_DATA_FORM.failure]: state => ({
    ...state,
    caseDataFormUpdateStatus: requestsStatuses.failure,
  }),

  [CLEAR_CASE_DATA_FORM]: () => defaultState,
  [HIDE_APPOINTMENT_INFO]: () => defaultState,
  [LOGOUT.success]: () => defaultState,
  [LOGOUT.failure]: () => defaultState,
});
